import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-header',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map